import {
  Clock3,
  Sparkles,
  RotateCcw,
  Eye,
  User,
  Bot,
} from "lucide-react";

const PromptHistory = ({ 
  history, onSelect, suggestions = [], onHistorySelect, selectedHistoryId
 }) => {

  const formatTime = (date) => {
  return new Date(date).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Optional: remove if you want 24-hour format
  });
};

  return (
    <div className="py-4 px-2 h-full flex flex-col">

      {/* Suggested Prompt */}
      {history.length === 0 && (
      <div className="mb-5">
        <div className="flex items-center gap-2 mb-3">
      
          <Sparkles
            size={16}
            className="text-violet-600"
          />
      
          <h3 className="font-semibold text-gray-800">
            Suggested Prompts
          </h3>
      
        </div>

        <div className="space-y-2">
      
          {suggestions.map((item, index) => (
      
            <button
              key={index}
              onClick={() => onSelect?.(item)}
              className="
                w-full
                text-left
                rounded-xl
                border
                border-violet-100
                bg-violet-50
                px-4
                py-3
                text-sm
                text-gray-700
                hover:bg-violet-100
                hover:border-violet-300
                transition-all
              "
            >
              ✨ {item}
            </button>
      
          ))}
      
        </div>
      
      </div>
    )}

 {/* Recent Queries */}
    {history.length > 0 && (
       <>
         <div className="flex items-center justify-between mb-3">
     
           <div className="flex items-center gap-2">
     
             <Clock3
               size={16}
               className="text-gray-500"
             />
     
             <h3 className="font-semibold">
               Recent Queries
             </h3>
     
           </div>
     
           <span className="text-xs text-gray-400">
             {history.length}
           </span>
     
         </div>
       </>
     )}

      {history.length === 0 ? (

        <div className="flex flex-col items-center justify-center text-center mt-16">
          <div className="h-14 w-14 rounded-full bg-violet-100 flex items-center justify-center">
            <Clock3
              size={26}
              className="text-violet-600"
            />
          </div>

          <h4 className="mt-4 font-medium text-gray-700">
            No Queries Yet
          </h4>

          <p className="text-sm text-gray-400 mt-1">
            Your recent AI prompts will appear here.
          </p>
        </div>
      ) : (

        <div className="space-y-3 px-2 overflow-y-auto custom-scrollbar">
          {history.map((item, index) => (
            <div
  key={item.id}
  className="space-y-2"
>
  {/* User */}
<div className="flex justify-end items-end gap-2">
  <div
    onClick={() => onHistorySelect(item)}
    className={`
      max-w-[85%]
      rounded-2xl
      rounded-br-md
      bg-violet-600
      text-white
      px-4
      py-3
      cursor-pointer
      transition
      hover:shadow-lg
      ${
        selectedHistoryId === item.id
          ? "ring-2 ring-violet-300"
          : ""
      }
    `}
  >
    <p className="text-sm">{item.text}</p>

    <div className="mt-2 flex justify-end text-[10px] text-violet-200">
      {formatTime(item.createdAt)}
    </div>
  </div>

  {/* User Avatar */}
  <div className="h-9 w-9 rounded-full bg-violet-600 flex items-center justify-center shadow">
    <User size={18} className="text-white" />
  </div>
</div>

{/* AI */}
<div className="flex justify-start items-end gap-2">
  {/* AI Avatar */}
  <div className="h-9 min-w-9 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 flex items-center justify-center shadow-md">
    <Sparkles
      size={18}
      className="text-white"
    />
  </div>

  <div
    onClick={() => onHistorySelect(item)}
    className={`
      max-w-[90%]
      rounded-2xl
      rounded-bl-md
      border
      bg-white
      px-4
      py-3
      cursor-pointer
      transition-all
      duration-200
      hover:border-violet-300
      hover:shadow-md
      ${
        selectedHistoryId === item.id
          ? "border-violet-500 bg-violet-50"
          : "border-gray-200"
      }
    `}
  >
    <p className="text-sm font-medium text-gray-800">
      {item.title}
    </p>

    <div className="mt-2 flex items-center gap-1 text-[11px] text-violet-600">
      <Eye size={12} />
      Click to open dashboard
    </div>
  </div>
</div>
</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PromptHistory;